export const Kinship = [
  {slug: 'conjuge', label: 'Cônjuge'},
  {slug: 'ex-conjuge', label: 'Ex-cônjuge'},
  {slug: 'companheiro', label: 'Companheiro(a) - União Estável'},
  {slug: 'filho', label: 'Filhos(as)'},
  {slug: 'enteado', label: 'Enteados(as)'},
  {slug: 'irmao', label: 'Irmãos(ãs)'},
  {slug: 'neto', label: 'Netos(as)'},
  {slug: 'bisneto', label: 'Bisnetos(as)'},
  {slug: 'menor-pobre', label: 'Menor Pobre'},
  {slug: 'pai-mae', label: 'Pais'},
  {slug: 'sogro', label: 'Sogro(a)'},
  {slug: 'avo', label: 'Avós(ôs)'},
  {slug: 'bisavo', label: 'Bisavós(ôs)'}
];
